import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '../../Services/permissions.service';
import { PermissionType } from '../../models/enum/permission.enum';

@Directive({
    selector: '[appHasPermission]'
})
export class HasPermissionDirective {

    @Input() set appHasPermission(strPermissions: string | string[]) {
        const permission = Array.isArray(strPermissions) ? strPermissions.map(x => this.stringToPermissionType(x))
            : this.stringToPermissionType(strPermissions);
        const hasPermission = Array.isArray(permission)
            ? this.permissionsService.hasAnyPermission(permission)
            : this.permissionsService.hasPermission(permission);

        hasPermission.then((res) => {
            if (res) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        });
    }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsService: PermissionsService
    ) { }

    stringToPermissionType(permission: string): PermissionType | undefined {
        return Object.values(PermissionType).find(
            (perm) => perm === permission
        ) as PermissionType;
    }
}